import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';

export function AddButton({ columnName, toggleModal, disabled = false }) {
  function onClick() {
    toggleModal(null, null, columnName);
  }

  return (
    <Button
      color="outline-primary-b"
      className="add-button text-center popover-toggle w-100 h-100 p-0 size-16"
      onClick={onClick}
      disabled={disabled}
    >
      <i className="icon-plus3 align-middle" aria-hidden /> Add a vehicle
    </Button>
  );
}

AddButton.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  columnName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
